export class CampusRequest {
    userID: string = "";
    accessId: string = "";
    schoolDistrictID: number = 0;

    constructor(userID: string, schoolDistrictID: number, accessId: string) {
        this.userID = userID;
        this.accessId = accessId;
        this.schoolDistrictID = schoolDistrictID;
    }
}